
import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, NgForm, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, finalize } from 'rxjs/operators';
import { AuthService } from '../../_services/auth.service';
import { FormKumiteFilter } from './form-kumite.models';

@Component({
  selector: 'form-kumite',
  templateUrl: './form-kumite.component.html',
  styleUrls: ['./form-kumite.component.css'],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => FormKumiteComponent), multi: true },
  ]
})

export class FormKumiteComponent implements ControlValueAccessor, OnInit {
  @Input() form: NgForm;
  @Input() label: string;
  @Input() required: boolean;
  @Input() disabled: boolean;
  @Input() name: string;
  @Input() set filter(value: FormKumiteFilter) {
    if (value !== this._filter) {
      this._filter = value;
    }
  }

  get filter(): FormKumiteFilter {
    if (!this._filter) {
      this.filter = new FormKumiteFilter();
    }
    return this._filter;
  }

  @Output('change') changeEvent = new EventEmitter();

  _filter: FormKumiteFilter;
  _errorMessage: string;
  _componenteInicializado: boolean;
  _identifier = `form-kumite-${identifier++}`;

  constructor(private _authService: AuthService) {
    this.required = false;
  }

  ngOnInit(): void {
    this.initializeSubjects();
  }

  _value: string;

  public get value(): string {
    return this._value;
  }

  public set value(v) {
    this._value = v;
    this._onChange(this._value);
    this._onTouched();
    this._kumiteId$.next(v);
  }

  _loading = false;
  _lookupKumitesUrl = `${AuthService.config.GatewayApi}/lookup/kumites`;
  _kumiteId$ = new Subject<string>();
  _kumiteInput$ = new Subject<string>();
  _kumites$ = new Subject<[]>();

  initializeSubjects() {
    this._kumiteId$.subscribe(id => {
      this._loading = true;
      this.filter.id = id;
      this._authService.post(this._lookupKumitesUrl, this.filter)
        .pipe(finalize(() => { this._loading = false; }))
        .subscribe(result => this._kumites$.next(result));
    });

    this._kumiteInput$.pipe(
      debounceTime(500),
      distinctUntilChanged())
      .subscribe(termo => {
        this._loading = true;
        this.filter.id = null;
        this.filter.termo = termo;
        this._authService.post(this._lookupKumitesUrl, this.filter)
          .pipe(finalize(() => { this._loading = false; }))
          .subscribe(result => this._kumites$.next(result));
      });
  }

  _ngModelChanged(evt) {
    this._onChange(evt);
  }

  _itemChanged(evt) {
    this.changeEvent.emit(evt);
  }

  //ControlValueAccessor Interface
  writeValue(obj: string): void {
    this._value = obj;
    this._kumiteId$.next(obj);

  }

  registerOnChange(fn: any) {
    this._onChange = fn;
  }
  registerOnTouched(fn: any) {
    this._onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean) {
    this.disabled = isDisabled;
  }

  _onChange: any = () => { };
  _onTouched: any = () => { };

}
let identifier = 0;
